import React, { Component } from "react";
import axios from "axios";

import { Card, Grid, TextField } from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

export default class AddUpdateAllYoutube extends Component {
  state = {
    home_youtube_id: "",
    franchise_youtube_1: "",
    franchise_youtube_2: "",

    notification: {
      open: false,
      color: "success",
      message: "",
    },
  };

  /* ---------------- LOAD EXISTING DATA ---------------- */
  componentDidMount() {
    if (init() !== "success") return;

    axios
      .get(Constants.getUrls.getAllYoutube)
      .then((res) => {
        if (res.data.status === "success" && res.data.data) {
          const d = res.data.data;
          this.setState({
            home_youtube_id: d.home_youtube_id || "",
            franchise_youtube_1: d.franchise_youtube_1 || "",
            franchise_youtube_2: d.franchise_youtube_2 || "",
          });
        }
      })
      .catch(() => {
        this.showNotification("error", "Failed to load YouTube data");
      });
  }

  /* ---------------- HELPERS ---------------- */
  showNotification = (color, message) => {
    this.setState({
      notification: {
        open: true,
        color,
        message,
      },
    });

    setTimeout(() => {
      this.setState({
        notification: { open: false, color: "", message: "" },
      });
    }, 2000);
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /* ---------------- SAVE (ADD / UPDATE) ---------------- */
  handleSubmit = () => {
    if (init() !== "success") return;

    const payload = {
      home_youtube_id: this.state.home_youtube_id,
      franchise_youtube_1: this.state.franchise_youtube_1,
      franchise_youtube_2: this.state.franchise_youtube_2,
    };

    axios
      .post(Constants.postUrls.saveAllYoutube, payload)
      .then((res) => {
        if (res.data.status === "success") {
          this.showNotification("success", res.data.message);
        }
      })
      .catch(() => {
        this.showNotification("error", "Something went wrong");
      });
  };

  /* ---------------- UI ---------------- */
  render() {
    const { home_youtube_id, franchise_youtube_1, franchise_youtube_2, notification } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                YouTube Settings
              </MDTypography>
            </MDBox>

            <MDBox p={3}>
              <Grid container spacing={3}>
                {/* HOME YOUTUBE */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Home Page YouTube ID"
                    name="home_youtube_id"
                    value={home_youtube_id}
                    onChange={this.handleInput}
                    placeholder="e.g. XyjPhppVIDA"
                  />
                </Grid>

                {/* FRANCHISE YOUTUBE 1 */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Abacus Online Youtube ID 1"
                    name="franchise_youtube_1"
                    value={franchise_youtube_1}
                    onChange={this.handleInput}
                  />
                </Grid>

                {/* FRANCHISE YOUTUBE 2 */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Abacus Online YouTube ID 2"
                    name="franchise_youtube_2"
                    value={franchise_youtube_2}
                    onChange={this.handleInput}
                  />
                </Grid>

                {/* SUBMIT */}
                <Grid item xs={12} align="right">
                  <MDButton color="info" onClick={this.handleSubmit}>
                    Save
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <MDSnackbar
            open={notification.open}
            color={notification.color}
            icon="notifications"
            title="YouTube Settings"
            content={notification.message}
            dateTime="Just now"
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
